<template>
  <div>
    <div class="container" v-if="isShow">
      <!-- 商机信息 -->
      <div class="card">
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg>
          <span style="flex: 1">{{payInfo.contPayCompanyName}}</span>
          <van-tag round :type="styleArr[payInfo.checkStatus]">{{ formatHandel('checkStatus',payInfo.checkStatus) }}</van-tag>
        </div>
        <van-tabs v-model="active">
          <van-tab title="付款信息">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">付款单位名称：</span>
                <span class="value">{{ payInfo.contPayCompanyName }}</span>
              </div>
              <div class="item" >
                <span class="key">收款银行账号：</span>
                <span class="value">{{ payInfo.incomeBankNo }}</span>
              </div>
              <div class="item" >
                <span class="key">付款银行帐号：</span>
                <span class="value">{{ payInfo.payBankAccountNo }}</span>
              </div>
              <div class="item">
                <span class="key">付款状态：</span>
                <span class="value">
                  <van-tag round type="success" v-if="payInfo.payStatus == 1">已付款</van-tag>
                  <van-tag round type="danger" v-if="payInfo.payStatus == 0">待付款</van-tag>
                </span>
              </div>
              <div class="item">
                <span class="key">预计/付款日期：</span>
                <span class="value">{{payInfo.payDate}}</span>
              </div>
              <!-- <div class="item" v-else>
                <span class="key">预计付款日期：</span>
                <span class="value">{{payInfo.expectPayDate}}</span>
              </div> -->
              <div class="item" style="width: 48%">
                <span class="key">付款金额：</span>
                <span class="value">{{payInfo.payMoney}}(元)</span>
              </div>
              <div class="item">
                <span class="key">付款截图：</span>
                <van-button type="info" size="mini" plain @click="showImg('payImg')" v-if="payInfo.payImg">点击查看</van-button>
                <span class="value" v-else>无</span>
                <!-- <span class="value">{{payInfo.payImg}}</span> -->
              </div>
              <div class="item">
                <span class="key">委托付款书：</span>
                <van-button type="info" size="mini" plain @click="showImg('agentBook')" v-if="payInfo.agentBook">点击查看</van-button>
                <span class="value" v-else>无</span>
              </div>
              <div class="item" v-if="payInfo.saveTime">
                <span class="key">原件归档日期：</span>
                <span class="value">{{payInfo.saveTime}}</span>
              </div>
              <div class="item" v-if="payInfo.submitTime">
                <span class="key">提交时间：</span>
                <span class="value">{{payInfo.submitTime}}</span>
              </div>
              <div class="item" v-if="payInfo.checkTime">
                <span class="key">确认时间：</span>
                <span class="value">{{payInfo.checkTime}}</span>
              </div>
              <div class="item">
                <span class="key">创建时间：</span>
                <span class="value">{{payInfo.createTime}}</span>
              </div>
              <div class="item" v-if="payInfo.checkReason" >
                <span class="key">审核意见：</span>
                <span class="value">{{ payInfo.checkReason }}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="收款明细" v-if="contForm.businessTypeName?contForm.businessTypeName.indexOf('品牌推广') == -1 && contForm.businessTypeName.indexOf('数字技术') == -1:false">
            <!-- <div v-if="payInfo.flowList.length == 0" style="text-align: center">暂无收款明细</div> -->
            <empty v-if="payInfo.flowList.length == 0" />
            <van-list :finished="finished" finished-text="没有更多了" v-if="payInfo.flowList.length > 0">
              <van-cell v-for="(item,index) in payInfo.flowList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div style="max-width: 100%">
                    <div v-if="contForm.custSource == '2'">
                      <span class="key"> 收款执行客户：</span>
                      <span class="value">{{ getExecCustomerName(item.execCustomerId) || '-'}}</span>
                    </div>
                    <div>
                      <span class="key"> 资金类型：</span>
                      <span class="value">{{ formatHandel('sysMoneyType',item.fundType) || '-' }}</span>
                    </div>
                    <div>
                      <span class="key"> 账户ID：</span>
                      <span class="value">{{ item.authIds || '-' }}</span>
                    </div>
                    <div>
                      <span class="key"> 金额(元)：</span>
                      <span class="value">{{ item.payMoney || '-' }}</span>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </van-tab>
          <van-tab title="操作日志">
            <div class="item">
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in operationLogList" :key="index">
                  <span style="font-weight: bold">{{item.remark}}</span>
                  <span style="margin-left: 8px">{{item.createTime}}</span>
                  <div v-for="(val,label) in item.listData" :key="label">
                    <div class="contLogSp">
                      <div>
                        <van-image style="width: 0.6rem; height: 0.6rem" :src="val.avatar" ></van-image>
                        <span style="margin-left: 10px;">{{val.userName}}</span>
                      </div>
                      <div>
                        <van-tag size="mini" :type="val.spStatus == 2?'success':val.spStatus == 3?'danger':'warning'">{{val.spStatus == 2?'已通过':val.spStatus == 3?'驳回':'审批中'}}</van-tag>
                        <span></span>
                        <span v-if="val.spTime" style="margin-left: 10px;">{{val.spTime}}</span>
                      </div>
                    </div>
                    <div v-if="val.spComment">{{val.spComment}}</div>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
          <van-tab title="合同信息">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">合同名称：</span>
                <span class="value">{{ contForm.contractName }}</span>
              </div>
              <div class="item" >
                <span class="key">合同编号：</span>
                <span class="value">{{ contForm.contractNum }}</span>
              </div>
              <div class="item" >
                <span class="key">执行时间：</span>
                <span class="value">{{ contForm.startTime }}至{{ contForm.endTime }}</span>
              </div>
              <div class="item" >
                <span class="key">收款单位：</span>
                <span class="value">{{contForm.companyName}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">垫款方式：</span>
                <span class="value">{{formatHandel('payType',contForm.payType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">框架类型：</span>
                <span class="value">{{formatHandel('frameType',contForm.frameType)}}</span>
              </div>
              <div class="item" style="width: 48%">
                <span class="key">客户来源：</span>
                <span class="value">{{formatHandel('custSource',contForm.custSource)}}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="合同项目" v-if="contForm.businessTypeName?contForm.businessTypeName.indexOf('品牌推广') == -1 && contForm.businessTypeName.indexOf('数字技术') == -1:false">
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">开户服务费（元）：</span>
                <span class="value">{{contForm.openAccountFee || '-'}}</span>
              </div>
              <div class="item" >
                <span class="key">代运营服务费：</span>
                <span class="value">{{contForm.agentBussFee || '-'}}%</span>
              </div>
              <div class="item" >
                <span class="key">素材费（元）：</span>
                <span class="value">{{contForm.materialMoney || '-'}}</span>
              </div>
            </div>
            <div v-if="pointList.length == 0" style="text-align: center">暂无返点数据</div>
            <van-list :finished="finished" finished-text="没有更多了" v-if="pointList.length > 0">
              <van-cell v-for="(item,index) in pointList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div style="max-width: 80%">
                    <div>
                      <span class="key"> 返点百分比值(%)：</span>
                      <span class="value">{{ item.percentage }}%</span>
                    </div>
                    <div>
                      <span class="key"> 返点消耗(元)：</span>
                      <span class="value">{{ item.useMoney }}(元)</span>
                    </div>
                    <div>
                      <span class="key"> 执行时间：</span>
                      <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
          </van-tab>
          <van-tab title="合同附件">
            <div class="item">
              <van-list :finished="fileFinished" finished-text="没有更多了"  @load="getContractFileList" v-if="contractFileList.length > 0">
                <van-cell v-for="(item,index) in contractFileList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div style="max-width: 80%">
                      <div>
                        <span class="key"> 附件类型：</span>
                        <span class="value">{{formatHandel('fileType',item.fileType)}}</span>
                      </div>
                      <div v-if="item.amount">
                        <span class="key"> 合同金额：</span>
                        <span class="value">{{ item.amount }}(元)</span>
                      </div>
                      <div v-if="item.fileDesc">
                        <span class="key"> 附件描述：</span>
                        <span class="value">{{ item.fileDesc }}</span>
                      </div>
                    </div>
                    <div style="display: flex;flex-direction:column;justify-content: space-around">
                      <a :href="item.url" @click="downloadUrlFile(item.url,item.title + '附件')">附件详情</a>
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="contractFileList.length == 0" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="3" v-if="payInfo.checkStatus != 2 && activeName != 1">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:payment:edit']" @click="edit">
            <van-icon name="edit" size="22" color="#07c160" />
            <span>修改</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:payment:remove']" @click="remove">
            <van-icon name="delete" size="22" color="#ee0a24" />
            <span>删除</span>
          </div>
        </van-grid-item>
        <van-grid-item >
          <div class="flex-center" v-if="payInfo.checkStatus == 0 || payInfo.checkStatus == 3" @click="submitReview(payInfo)">
            <van-icon name="certificate" size="22" color="#1989fa" />
            <span>提交草稿</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid class="grid-wrap" :column-num="1" v-if="payInfo.checkStatus != 2">
        <van-grid-item v-if="payInfo.checkStatus == 1 && activeName == 1">
          <div class="flex-center" v-hasPermi="['cont:payment:reviewer']" @click="examine(payInfo)">
            <van-icon name="certificate" size="22" color="#1989fa" />
            <span>收款确认</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-dialog v-model="verifyFormShow" title="收款确认" width="95%" style="height:45%" class="verifyClue" :beforeClose="verifyBeforeClose" show-cancel-button>
        <van-form ref="verifyForm" validate-trigger="onSubmit">
          <van-cell title="确认状态：" required>
            <template>
              <van-radio-group v-model="verifyForm.checkStatus" direction="horizontal">
                <van-radio name="2" clickable @click="verifyForm.checkStatus = '2'">确认到账</van-radio>
                <van-radio name="4" clickable @click="verifyForm.checkStatus = '4'">驳回</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-if="verifyForm.checkStatus == '4'" readonly clickable v-model="verifyForm.checkReasonTypeName" @click="showPicker('checkReasonType')" label="驳回原因" placeholder="请选择驳回原因" :rules="[{ required: true }]" required />
          <van-field
            v-model="verifyForm.checkReason"
            rows="2"
            autosize
            label="审核意见"
            placeholder="请输入审核意见"
            type="textarea"
            show-word-limit
            :rules="verifyForm.checkStatus == '4'?[{ required: true }]:[]" :required="verifyForm.checkStatus == '4'?true:false"
          />
        </van-form>
      </van-dialog>
      <van-image-preview v-model="imageShow" :images="imageArr">
        <!-- <template v-slot:index>第{{ index }}页</template> -->
      </van-image-preview>
      <!-- <van-popup v-model="picker.visible" position="bottom">
        <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
      </van-popup> -->
      <dialog-payment :show='paymentFormShow' :isAdd="false" :modifyObj="payInfo" :contractId="payInfo.contractId" @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose'></dialog-payment>
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import { getDicts } from '@/api/system/dict/data'
import newContract from '@/api/cont/newContract'
import { Toast, Dialog, ImagePreview } from 'vant'
import DialogPayment from '../components/DialogPayment.vue'
import Empty from '@/components/common/Empty'
export default {
  components: {
    Empty,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component,
    DialogPayment
  },
  data() {
    return {
      isShow: false,
      active: 0,
      activeName: '',
      contIncomeId: '',
      paymentFormShow: false,
      contForm: {},
      pointList: [],
      executiveList: [],
      finished: true,
      payInfo: {},
      operationLogList: [], // 操作日志
      contractFileList: [], // 合同附件
      fileFinished: true,
      verifyFormShow: false,
      verifyForm: {
        checkStatus: '2',
        checkReason: '',
        contIncomeId: ''
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      styleArr: ['success', 'warning', 'primary', 'danger'],
      options: {
        checkStatusOptions: [],
        frameTypeOptions: [],
        sysMoneyTypeOptions: [],
        checkReasonTypeOptions: [],
        fileTypeOptions: []
      },
      imageShow: false,
      imageArr: []
    }
  },
  async created() {
    const { id, active } = this.$route.query
    this.activeName = active
    this.contIncomeId = id
    await this.getOptions()
    await this.getPayInfo()
    this.getDicts('check_reason_type').then(res => {
      this.options.checkReasonTypeOptions = this.setDictToInt(res)
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '添加收款详情'
      // this.getpayInfo()
    },
    async getPayInfo(id) {
      const res = await payment.getPayment(id || this.$route.query.id)
      if (res.code === 200) {
        this.payInfo = res.data
        this.isShow = true
        // this.options.contactIdOptions = []
        const uLis = res.data.contactList || []
        for (let i = 0; i < uLis.length; i++) {
          const element = uLis[i]
          const item = {
            dictValue: element.contactId,
            dictLabel: element.contactName
          }
          this.options.contactIdOptions.push(item)
        }
      }
      // 框架类型
      await getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      await getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      await getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      // 附件类型
      await getDicts('file_type').then(res => {
        this.options.fileTypeOptions = res.data
      })
      newContract.getContract(this.payInfo.contractId).then(res => {
        this.contForm = res.data
      })
      const params = {
        contractId: this.payInfo.contractId
      }
      newContract.getRebateList(params).then(res => {
        this.pointList = res.rows
      })
      await payment.listExecutive(params).then(response => {
        if (response.code === 200) {
          this.executiveList = response.rows
        }
      })
      this.getDicts('sys_money_type').then(res => {
        this.options.sysMoneyTypeOptions = this.setDictToInt(res)
      })
      this.getLogList()
      this.getContractFileList()
    },
    // 获取操作记录
    async getLogList() {
      const params = {
        contractId: this.contIncomeId,
        bigType: 2
      }
      newContract.listContractLog(params).then(response => {
        this.operationLogList = response.rows
      })
    },
    // 获取合同附件列表
    async getContractFileList() {
      newContract.listContractFile({ contractId: this.payInfo.contractId }).then(response => {
        this.contractFileList = response.rows
      })
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url2, true)
      xhr.responseType = 'blob'
      // xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }
      xhr.send()
    },
    getExecCustomerName(id) {
      console.log(id)
      if (this.executiveList.find(res => { return res.execCustomerId == id })) {
        return this.executiveList.find(res => { return res.execCustomerId == id }).execCustomerName
      }
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'execCustomer') {

      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'

      if (this.picker.formKey === 'contract') {

      } else {
        this.verifyForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.verifyForm[name] = this.options[optionItem][key].dictLabel
      }

      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    // 添加回访记录
    addVisit() {
      this.visitShow = true
    },
    // 添加联系人
    addContacts() {
      this.contactsShow = true
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    edit() {
      this.paymentFormShow = true
    },
    async remove() {
      Dialog.confirm({
        message: '是否确认删除此条打款记录'
      })
        .then(() => {
          payment.deletePayment(this.contIncomeId).then(res => {
            if (res.code === 200) {
              Toast.success('删除成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.message)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    async submitReview() {
      Dialog.confirm({
        message: '是否确认提交审核此条打款记录'
      })
        .then(() => {
          payment.updatePayment({ contIncomeId: this.contIncomeId, checkStatus: 1 }).then(res => {
            if (res.code === 200) {
              Toast.success('提交审核成功')
              setTimeout(() => {
                this.getPayInfo()
              }, 500)
            } else if (res.code == 400) {
              Toast.fail('信息填写不完整，请先完善信息')
              setTimeout(() => {
                this.paymentFormShow = true
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    examine() {
      this.verifyFormShow = true
    },
    handleAddContractCancel() {
      this.paymentFormShow = false
    },
    // 添加合同
    async addContractBeforeClose() {
      this.paymentFormShow = false
      await this.getPayInfo()
    },
    // verifyBeforeClose() {
    //   this.verifyFormShow = false
    // },
    // 审核
    async verifyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.verifyForm.validate()
          this.verifyForm.contIncomeId = this.contIncomeId
          payment.reviewerPayment(this.verifyForm).then(response => {
            this.verifyFormShow = false
            this.verifyForm.checkReason = ''
            Toast.success('确认成功!')
            setTimeout(() => {
              payment.listPayment({ checkStatus: '1', orderByColumn: 'createTime', isAsc: 'desc' }).then(res => {
                if (res.code == 200) {
                  if (res.rows.length > 0 && !this.$route.query.type) {
                    this.getPayInfo(res.rows[0].contIncomeId)
                    this.contIncomeId = res.rows[0].contIncomeId
                  } else {
                    // this.$router.push({
                    //   path: '/cont/payment/confirmList',
                    //   query: {
                    //     status: '2'
                    //   }
                    // })
                    this.$router.push({
                      path: '/daiban',
                      query: { type: 2 }
                    })
                  }
                }
              })
            }, 500)
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    getOptions() {
      // 审核状态
      this.getDicts('check_status').then(res => {
        this.options.checkStatusOptions = this.setDictToInt(res)
      })
      // 框架类型
      this.getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = this.setDictToInt(res)
      })
    },
    showImg(val) {
      this.imageArr = []
      this.imageArr.push(this.payInfo[val])
      this.imageShow = true
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 64%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
/deep/.van-list{
  padding: 0;
}
</style>
